var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowColumninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 159,
    viewBox: "0 0 87 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.927 4.964a1.187 1.187 0 00-.773-1.49L74.972.245a1.187 1.187 0 10-.717 2.263l9.05 2.87-2.87 9.05a1.187 1.187 0 002.263.717l3.229-10.181zM2.975 158.312c2.054-3.33 3.297-7.45 4.131-12.126.834-4.68 1.272-10.002 1.665-15.768.788-11.57 1.402-25.018 4.595-39.274 6.36-28.4 22.97-60.075 71.975-85.486L84.25 3.552c-49.656 25.747-66.693 58.02-73.2 87.075-3.24 14.472-3.863 28.128-4.646 39.63-.393 5.769-.825 10.975-1.634 15.513-.81 4.542-1.984 8.33-3.814 11.297l2.02 1.246z",
    fill: "#fff"
  })));
}

export default SvgArrowColumninline;